<template>
  <div :id="id" style="width: 100%;height: 46px;position:relative;z-index:99;">
     

  </div>

</template>

<script>
import * as echarts from 'echarts';
export default {
  name: 'line',
  props: {
      id: {
          type: String,
          default: ''
      },
      xData: {
          type: Array,
      },
      yData: {
          type: Array,
      }
  },
  data() {
      return {  
      };
  },

  components: {}, 

  watch: {

  },

  mounted() {
      this.initChart()
  },
  methods: {
      initChart(){
          console.log('X的值',this.xData)
          var chartDom = document.getElementById(this.id);
          var myChart = echarts.init(chartDom);
          var option;
          option = {
              xAxis: {
                  type: 'category',
                  data: this.xData,
                  show: false
              },
              yAxis: {
                  type: 'value',
                  show: false
              },
              grid:{ // 让图表占满容器
                  top:"5px",
                  left:"0px",
                  right:"0px",
                  bottom:"5px"
              },
              tooltip: {
                  trigger: 'axis',
                  axisPointer: {
                      type: 'none'
                  }
              },
              series: [
                  {
                  itemStyle: {
                      normal: {
                      color: '#FF005A',
                      lineStyle: {
                          color: '#FF005A',
                          width: 1.5
                      }
                      }
                  },
                  areaStyle: {
                      normal: {
                          color: new echarts.graphic.LinearGradient(
                              0,
                              0,
                              0,
                              1,
                              [
                              {
                                  offset: 0,
                                  color: '#ffebf3'
                              },
                              {
                                  offset: 0.8,
                                  color: 'rgba(255,255,255,0.1)'
                              }
                              ],
                              false
                          )
                          }
                      },
                      smooth: true,
                      showSymbol: false,
                      type: 'line',
                      data: this.yData
                  },
              ]
          };
          option && myChart.setOption(option);
      }
  },
};
</script>

<style lang="less" scoped>

</style>